var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRatingIconBlack(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.56059 0.995997C7.72907 0.61411 8.27093 0.614109 8.43941 0.995996L10.3577 5.34402C10.4274 5.50207 10.5766 5.6105 10.7485 5.62797L15.4765 6.10872C15.8917 6.15095 16.0592 6.66629 15.748 6.94453L12.2056 10.1125C12.0768 10.2277 12.0198 10.4031 12.0563 10.572L13.0601 15.2171C13.1483 15.6251 12.7099 15.9436 12.3491 15.7337L8.24154 13.3435C8.09223 13.2567 7.90777 13.2567 7.75846 13.3435L3.65086 15.7337C3.29009 15.9436 2.85171 15.6251 2.93987 15.2171L3.94368 10.572C3.98017 10.4031 3.92317 10.2277 3.7944 10.1125L0.251956 6.94453C-0.0591779 6.66629 0.108266 6.15095 0.523526 6.10872L5.25151 5.62797C5.42337 5.6105 5.57261 5.50207 5.64234 5.34402L7.56059 0.995997Z",
    fill: "#303030"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRatingIconBlack);
export default __webpack_public_path__ + "static/media/ratingIconBlack.1ec60dbe7fbad0a8eb53eef7339fef68.svg";
export { ForwardRef as ReactComponent };